import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=61a54d97&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=61a54d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a54d97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a54d97')) {
      api.createRecord('61a54d97', component.options)
    } else {
      api.reload('61a54d97', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=61a54d97&scoped=true&", function () {
      api.rerender('61a54d97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25OhcF1KXrnRx/JS/comp/GuestBox.vue"
export default component.exports